module.exports = __webpack_public_path__ + "img/13-about.0808bebe.jpg";